module.exports = __webpack_public_path__ + "img/eleven.d7afe240.png";